export default __webpack_public_path__ + "static/media/la.79a72be9.svg";